import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Box } from 'reflexbox/styled-components'

export const Label = styled.label(
  ({ theme }) => css`
    position: absolute;
    left: 24px;
    top: -8px;

    color: ${theme.colors.grays.N500};
    background-color: #fff;
    padding: 0 8px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.label};
    font-weight: ${theme.fontWeights.extraBold};

    transition: color 0.2s;
  `,
)

export const ErrorText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes[0]};
    line-height: 1em;
  `,
)

const Input = styled.textarea(
  ({ theme, error }) => css`
    display: block;
    width: 100%;
    border: 1px solid;
    border-color: ${theme.colors.grays.N500};
    border-radius: 8px;
    padding: 12px;
    transition: all 0.2s;
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.body};
    color: ${theme.colors.text};

    :focus {
      border-color: ${theme.colors.primary};
      box-shadow: ${theme.shadows.under[1]};
    }

    :focus ~ ${Label} {
      color: ${theme.colors.primary};
    }

    :disabled {
      border-color: ${theme.colors.grays.N300};
      background-color: transparent;
      color: ${theme.colors.grays.N500};

      ::placeholder {
        color: ${theme.colors.grays.N300};
      }
    }

    :disabled ~ ${Label} {
      color: ${theme.colors.grays.N300};
    }

    ${error &&
      css`
        &,
        :focus {
          border-color: ${theme.colors.error};
        }

        & ~ ${Label}, :focus ~ ${Label} {
          color: ${theme.colors.error};
        }
      `}
  `,
)

const TextArea = ({ label, error, ...props }) => (
  <Box sx={{ position: 'relative' }} {...props}>
    <Input error={error} {...props} />

    {label && <Label>{label}</Label>}

    {error && <ErrorText>{error}</ErrorText>}
  </Box>
)

TextArea.propTypes = {
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  ...Box.propTypes,
}

export default TextArea
